/**
 * @generated SignedSource<<e8240abc44b100e9294cbcdba8b5f736>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type StorecastFocusQuery$variables = {
  id: string;
};
export type StorecastFocusQuery$data = {
  readonly dashboard: {
    readonly focusedDetailItemId: string | null;
    readonly focusedNodeId: string | null;
  } | null;
};
export type StorecastFocusQuery = {
  response: StorecastFocusQuery$data;
  variables: StorecastFocusQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "focusedNodeId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "focusedDetailItemId",
      "storageKey": null
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "StorecastFocusQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Dashboard",
        "kind": "LinkedField",
        "name": "dashboard",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "StorecastFocusQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Dashboard",
        "kind": "LinkedField",
        "name": "dashboard",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "a735c9e1e9eacc1f333fbbdc4db1cc55",
    "id": null,
    "metadata": {},
    "name": "StorecastFocusQuery",
    "operationKind": "query",
    "text": "query StorecastFocusQuery(\n  $id: ID!\n) {\n  dashboard(id: $id) {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "634fadd34c0c154c0f1c54ee7dcc884b";

export default node;
